import React from 'react';
import { Box } from '@mui/material';
import { Loading } from 'Components';

export const LoadingState = () => {
  return (
    <Box
      sx={{
        width: "280px",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '200px',
        padding: '40px 20px',
        minHeight: '200px',
      }}
    >
      <Loading show />
    </Box>
  );
};

LoadingState.propTypes = {};
